<template lang="pug">
  v-layout(align-start='')
    v-flex
      v-data-table.elevation-1(:headers='headers' item-key='ventas' :items='ventas' :search='search' sort-by='nombre' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top='')
          v-toolbar(color='primary', dark)
            v-toolbar-title.justify-center Ventas
            v-divider.mx-4(inset vertical)
            v-spacer
            v-text-field.text-xs-center(v-model='search', label='Búsqueda', single-line hide-details color='success')
            v-spacer
            v-dialog(v-model='dialogShow' scrollable persistent max-width='80%')
              v-card(color='grey_1')
                v-app-bar(dark color='primary')
                  v-toolbar-title.headline {{ formTitle }}
                v-card-text
                  v-row(dense)
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-subtitle.title(style='color: black') Información de la Venta
                        v-card-text
                          v-row(dense)
                            v-col(cols='12', sm='12', md='3')
                              v-text-field(dense readonly outlined v-model='editedItem.numFactura', label='Numero de Factura')
                            v-col(cols='12', sm='12', md='3')
                              v-text-field(dense readonly outlined v-model='editedItem.tipoVenta', label='Tipo de Venta')
                            v-col(cols='12', sm='12', md='3')
                              v-text-field(dense readonly outlined v-model='editedItem.fechaVencimiento', label='Fecha de Vencimiento')
                            v-col(cols='12', sm='12', md='3')
                              v-text-field(dense readonly outlined v-model='editedItem.fechaCreacion', label='Fecha de Creación')
                            //- v-row
                              //- v-col(cols='12', sm='6')
                              //-   v-text-field(dense readonly outlined v-model='editedItem.numControl', label='Numero de Control')
                              //- v-col(cols='12', sm='6')
                              //-   v-text-field(dense readonly outlined label='Vendedor')
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense)
                            v-col(cols='12', sm='12', md='12')
                              ListadoProducto(p='activar', v-model='editedItem.detalleProducto')
                          p
                          v-row(dense class='d-flex justify-end')
                            v-col(cols='4' sm='4' md='4')
                              v-text-field(dense readonly outlined :value='editedItem.subTotal | read', label='Subtotal')
                            v-col(cols='4' sm='4' md='4')
                              v-text-field(dense readonly v-model='editedItem.total' outlined label='Total + IVA')
                            //- v-col(cols='4' sm='4' md='4')
                            //-   v-text-field(dense readonly :value='editedItem.gravado | read', outlined label='Gravado')
                            //- v-col(cols='4' sm='4' md='4')
                            //-   v-text-field(dense readonly :value='editedItem.exento | read', outlined label='Exento')
                            //- v-row(class='d-flex justify-end')
                            //- v-col(cols='4' sm='4' md='4')
                            //-   v-text-field(dense readonly :value='editedItem.total | read', outlined label='Total + IVA')
                v-card-actions
                    v-spacer
                    v-btn(color='error' small dark @click='close')
                      v-icon mdi-close
                      | Cerrar
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2', @click='showItem(item)' v-on="on") mdi-eye
            | Visualizar
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(@click='exportPDF(item)' color='primary_2' v-on="on") mdi-pdf-box
            | Generar PDF
        template(v-slot:no-data='')
          h1 No hay datos de ventas asociadas
      FacturaVenta(:dialogFacturaVenta = 'dialogFacturaVenta' @close = 'closeF')    
</template>

<script>
import Api from '@/services/methods'
import ListadoProducto from '../components/ListadoProducto'
import { EventBus } from '../Events'
import FacturaVenta from '../components/reportes/FacturaVenta'
export default {
  name: 'pdf',
  data: () => ({
    dialogFacturaVenta: false,
    dialog: false,
    dialogShow: false,
    dialogPedido: false,
    modalEmi: false,
    loading: true,
    modalven: false,
    dialog1: false,
    read: false,
    items: ['Credito', 'Debito'],
    dateEmision: new Date().toISOString().substr(0, 10),
    selectedPedido: [],
    select: [],
    pedido: [],
    headers: [
      { text: 'Factura', value: 'numFactura', align: 'center' },
      { text: 'Nro Pedido', value: 'idPedido.numeroPedido', align: 'center' },
      { text: 'Cliente', value: 'idCliente.nombre', align: 'center' },
      { text: 'Fecha de vencimiento', value: 'fechaVencimiento', align: 'center' },
      { text: 'Monto Total(Bs)', value: 'total', align: 'center' },
      { text: 'Tipo de Venta', value: 'tipoVenta', align: 'center' },
      { text: 'Estatus', value: 'estatus', align: 'center' },
      { text: 'Acciones', value: 'action', sortable: false, align: 'center' }
    ],
    cliente: [],
    idClienteArray: [],
    clientePedido: [],

    vendedor: [],
    idVendedorArray: [],

    search: '',
    nombreUsuario: '',
    permisosRuta: {},
    ventas: [],
    editedIndex: -1,
    editedItem: {
      numFactura: 0,
      numControl: 0,
      fechaCreacion: '',
      fechaVencimiento: '',
      tipoVenta: '',
      total: 0,
      exento: 0,
      gravado: 0,
      baseImponible: 0,
      subTotal: 0,
      idPedido: [],
      codigoPedido: '',
      detalleProducto: [],
      idCliente: [],
      estatus: ''
    },
    defaultItem: {
      numFactura: 0,
      numControl: 0,
      fechaCreacion: '',
      fechaVencimiento: '',
      tipoVenta: '',
      total: 0,
      exento: 0,
      gravado: 0,
      baseImponible: 0,
      subTotal: 0,
      idPedido: [],
      codigoPedido: '',
      detalleProducto: [],
      estatus: ''
    }
  }),

  components: {
    ListadoProducto,
    FacturaVenta
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nueva Venta' : 'Detalles'
    }
  },
  watch: {
    // dialog(val) {
    //   val || this.close();
    //   console.log(this.editedItem.idCliente.nombre);
    //   console.log(this.editedItem.idVendedor.nombreVendedor);
    // },
    // dialogShow(val) {
    //   val || this.close();
    //   console.log(this.editedItem.idCliente.nombre);
    //   console.log(this.editedItem.idVendedor.nombreVendedor);
    // }
  },
  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.listarVentas()
      this.buscarUsuario()
      this.permisosRuta = this.$store.state.empresa[0].permisos.find(
        permiso => permiso.ruta === 'Venta'
      )
    },

    listarVentas () {
      Api.get('/venta')
        .then(response => {
          this.ventas = response.data
          console.log('VENTAS', this.ventas)
          this.ventas.map(data => {
            data.fechaCreacion = this.formato(data.fechaCreacion)
            if (data.fechaVencimiento) data.fechaVencimiento = this.formato2(data.fechaVencimiento)
            data.total = (parseFloat(data.total)).toFixed(2)
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              //text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    buscarUsuario () {
      Api.get('usuario', this.$store.state.usuario._id)
        .then(res => {
          this.nombreUsuario = res.data[0].nombre
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    exportPDF (item) {
      // Bus a FacturaVenta.vue
      let array = {
        editedItem: item,
        nombreUsuario: this.nombreUsuario,
      }
      EventBus.$emit('dataFacturaVenta', array)
      this.dialogFacturaVenta = true
    },
    
    formato (fecha) {
      return this.$moment(fecha).format('DD-MM-YYYY, HH:mm:ss')
    },

    formato2 (fecha) {
      return this.$moment(fecha).format('DD-MM-YYYY')
    },

    Pedido () {
      this.dialogPedido = !this.dialogPedido
      this.listarPedidos()
    },

    validarCrear () {
      return this.permisosRuta?.accion.includes('Crear')
    },
    validarModificar () {
      return this.permisosRuta?.accion.includes('Modificar')
    },
    validarEliminar () {
      return this.permisosRuta?.accion.includes('Eliminar')
    },

    

    listarPedidos () {
      Api.get('pedido')
        .then(res => {
          this.pedido = res.data
          this.select = []
          this.pedido.map(data => {
            this.select.push({
              text: data.codigoPedido,
              value: data._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              //text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    editItem (item) {
      this.editedIndex = this.ventas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      this.dialogPedido = false
    },

    showItem (item) {
      this.editedIndex = this.ventas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogShow = true
    },

    deleteItem (item) {
      const index = this.ventas.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quiere borrar?',
        text: 'No podrá revertir',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.ventas.splice(index, 1)
          Api.delete('/venta/' + item._id).then(response => {
            console.log(response)
          })
        }
      })
    },

    close () {
      this.dialog = false
      this.dialogShow = false
      this.clientePedido = []
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    closeF () {
      this.dialogFacturaDirecta = false
    },

    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },
  }
}
</script>
